(function() {
  var btn = document.getElementById('pp-scroll-top');
  if (!btn) return;
  var atc = document.querySelector('.product-form__submit');
  var hasBeenVisible = false;

  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', function() {
    if (!atc) return;
    var rect = atc.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      hasBeenVisible = true;
    }
    if (hasBeenVisible && rect.bottom < 0) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }, { passive: true });
})();
